import { frontendURL } from '../../../helper/URLHelper';
import { FEATURE_FLAGS } from '../../../featureFlags';
export const routes = [
  {
    path: frontendURL('accounts/:accountId/workflows'),
    component: () => import('./WorkflowAccess.vue'),
    meta: {
      featureFlag: FEATURE_FLAGS.WORKFLOW_BUILDER,
      permissions: ['administrator'],
    },
    children: [
      {
        path: '',
        name: 'workflows_index',
        component: () => import('./WorkflowListPage.vue'),
      },
      {
        path: 'new',
        name: 'workflows_new',
        component: () => import('./WorkflowEditorPage.vue'),
      },
      {
        path: 'groups',
        name: 'workflow_groups_index',
        component: () => import('./WorkflowGroupsPage.vue'),
      },
      {
        path: 'groups/new',
        name: 'workflow_groups_new',
        component: () => import('./WorkflowGroupPage.vue'),
      },
      {
        path: 'groups/:groupId',
        name: 'workflow_groups_edit',
        component: () => import('./WorkflowGroupPage.vue'),
      },
      {
        path: ':workflowId/executions/:executionId?',
        name: 'workflows_executions',
        component: () => import('./WorkflowExecutionsPage.vue'),
      },
      {
        path: ':workflowId/versions/:versionId?',
        name: 'workflows_versions',
        component: () => import('./WorkflowVersionsPage.vue'),
      },
      {
        path: ':workflowId',
        name: 'workflows_edit',
        component: () => import('./WorkflowEditorPage.vue'),
      },
    ],
  },
];
